import { useEffect, useState } from 'react';
import { history } from '@umijs/max';
import { isPdaPagePath } from '@/utils/appRouteAccess';
import RealtimeProvider from './RealtimeProvider';

/** PDA 的 layout:false 不经过桌面布局，在根容器单独挂实时连接，不改变页面树。 */
export default function PdaRealtimeBridge() {
  const [pathname, setPathname] = useState(() => history.location.pathname);
  useEffect(() => history.listen(({ location }) => setPathname(location.pathname)), []);
  if (!isPdaPagePath(pathname) || pathname === '/pda/login') return null;
  // Provider 自身检查 ERP 登录 token；公开供应商页面和桌面页面均不会在这里连接。
  return <RealtimeProvider />;
}
